<template>
  <div class="companies-page fullheight">
    <Row class="fullheight">
      <i-col span="6" class="fullheight filter-category-col">
        <FilterCategory @explore="handleExplore"/>
      </i-col>
      <i-col span="18" class="fullheight companies-col">
        <div class="fullheight">
          <CompaniesList ref="CompaniesList" class="companies-list"/>
        </div>
      </i-col>
    </Row>
    <ShortlistSelection ref="ShortlistSelection" />
  </div>
</template>

<script>
import FilterCategory from '@/components/companies/FilterCategory'
import CompaniesList from '@/components/companies/CompanyCardList'
import ShortlistSelection from '@/components/companies/ShortListSelection'

export default {
  components: {
    FilterCategory,
    CompaniesList,
    ShortlistSelection
  },

  methods: {
    handleExplore () {
      this.$refs.CompaniesList.getCompanies()
    }
  }
}
</script>

<style lang="scss" scoped>
.companies-page {
  .filter-category-col {
    background: #ffffff;
    padding: 20px;
    box-shadow: 0 -2px 5px 0 rgba(0, 0, 0, .07%);
  }
  .companies-col {
    padding: 20px;
  }
}
</style>
